// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const geodude: PokeData = {
  "id": 74,
  "name": "geodude",
  "height": 4,
  "weight": 200,
  "base_experience": 60,
  "types": [
    PokeType.ROCK,
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "double-edge",
    "rock-throw",
    "earthquake",
    "harden",
    "defense-curl",
    "bide",
    "self-destruct",
    "explosion",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "rollout",
    "magnitude",
    "mud-sport",
    "iron-defense",
    "rock-blast",
    "rock-polish",
    "stone-edge",
    "stealth-rock",
    "smack-down",
    "bulldoze"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "earthquake",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "rock-blast",
    "stealth-rock",
    "rototiller",
    "ancient-power",
    "fissure",
    "boulder_bash"
  ],
  "evolution_chain": {
    "id": 31,
    "item": null,
    "species": [
      {
        "name": "geodude",
        "order": 80,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "graveler",
        "order": 81,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 74,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "golem",
        "order": 82,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 75,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 20,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
